<app-breadcrumb [title]="title"></app-breadcrumb>

<div class="container-fluid my-5">
  <div class="row">
    <div class="col">
      <div class="d-flex justify-content-between align-items-center pb-2 mb-3 border-bottom">
        <h3 class="h6 fw-bold mb-0">{{ title }}</h3>
        <a [routerLink]="['/management/employees/service-book', profileId,financialYearId]" class="btn btn-outline-primary">Cancel</a>
      </div>

      <app-loader [show]="skeleton"></app-loader>
      <div [class.d-none]="skeleton">
        <form [formGroup]="serviceBookForm" (ngSubmit)="save()">
          <input type="hidden" formControlName="id">
          <input type="hidden" formControlName="isActive">
          <input type="hidden" formControlName="isPresent">

          <div class="border rounded p-3 mb-3">
            <div class="row">
              <div class="col-md-4">
                <div class="form-group mb-3">
                  <label class="form-label" for="schoolLevelId">Department</label>
                  <select MyInput formControlName="schoolLevelId" class="form-select form-select-sm"
                    (change)="changeDepartment($event.target.value)">
                    <option value="" selected>--SELECT--</option>
                    <option *ngFor="let item of schoolLevels" value="{{ item.value }}">{{ item.text }}
                    </option>
                  </select>
                  <my-error controlName="schoolLevelId" errorKey="required">Department is required.</my-error>
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group mb-3" *ngIf="serviceBookForm.get('schoolLevelId').value == 1">
                  <label class="form-label" for="regionId">Region</label>
                  <select MyInput formControlName="regionId" class="form-select form-select-sm"
                    (change)="getStates($event.target.value)">
                    <option value="" selected>--SELECT--</option>
                    <option *ngFor="let item of regions" value="{{ item.value }}">{{ item.text }}
                    </option>
                  </select>
                  <my-error controlName="regionId" errorKey="required">Region is required.</my-error>
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group mb-3" *ngIf="serviceBookForm.get('schoolLevelId').value == 1">
                  <label class="form-label" for="stateId">State</label>
                  <select MyInput formControlName="stateId" class="form-select form-select-sm"
                    (change)="getDistricts($event.target.value)">
                    <option value="" selected>--SELECT--</option>
                    <option *ngFor="let item of states" value="{{ item.value }}">{{ item.text }}
                    </option>
                  </select>
                  <my-error controlName="stateId" errorKey="required">State is required.</my-error>
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group mb-3" *ngIf="serviceBookForm.get('schoolLevelId').value == 1">
                  <label class="form-label" for="districtId">District</label>
                  <select MyInput formControlName="districtId" class="form-select form-select-sm"
                    (change)="getSchools($event.target.value)">
                    <option value="" selected>--SELECT--</option>
                    <option *ngFor="let item of districts" value="{{ item.value }}">{{ item.text }}
                    </option>
                  </select>
                  <my-error controlName="districtId" errorKey="required">District is required.</my-error>
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group mb-3">
                  <label class="form-label" for="schoolId">School</label>
                  <select MyInput formControlName="schoolId" class="form-select form-select-sm">
                    <option value="" selected>--SELECT--</option>
                    <option *ngFor="let item of schools" value="{{ item.value }}">{{ item.text }}
                    </option>
                  </select>
                  <my-error controlName="schoolId" errorKey="required">School is required.</my-error>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4">
                <div class="form-group mb-3">
                  <label class="form-label" for="designationId">Designation</label>
                  <select MyInput formControlName="designationId" class="form-select form-select-sm">
                    <option value="" selected>--SELECT--</option>
                    <option *ngFor="let item of designations" value="{{ item.value }}">{{ item.text }}
                    </option>
                  </select>
                  <my-error controlName="designationId" errorKey="required">Designation is required.</my-error>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4">
                <div class="form-group mb-3">
                  <label class="form-label" for="durationFrom">From</label>
                  <div class="input-group">
                    <span class="input-group-text">
                      <i-bs name="calendar3" width="1em" height="1em"></i-bs>
                    </span>
                    <input MyInput formControlName="durationFrom" placeholder="dd-mm-yyyy"
                      class="form-control form-control-sm datepicker" [minDate]="{year: year - 60, month: 1, day: 1}"
                      [maxDate]="{year: year, month: 12, day: 31}" ngbDatepicker #durationFrom="ngbDatepicker"
                      (click)="durationFrom.toggle()" />
                  </div>
                  <my-error controlName="durationFrom" errorKey="required">From is required.</my-error>
                  <my-error controlName="durationFrom" errorKey="pattern">Date pattern invalid.</my-error>
                </div>
              </div>
              <div class="col-md-4" [class.d-none]="serviceBookForm.get('isPresent').value">
                <div class="form-group mb-3">
                  <label class="form-label" for="durationTo">To</label>
                  <div class="input-group">
                    <span class="input-group-text">
                      <i-bs name="calendar3" width="1em" height="1em"></i-bs>
                    </span>
                    <input MyInput formControlName="durationTo" class="form-control form-control-sm datepicker"
                      [minDate]="{year: year - 60, month: 1, day: 1}" [maxDate]="{year: year, month: 12, day: 31}"
                      ngbDatepicker #durationTo="ngbDatepicker" (click)="durationTo.toggle()" />
                  </div>
                  <my-error controlName="durationTo" errorKey="required">To is required.</my-error>
                  <my-error controlName="durationTo" errorKey="pattern">Date pattern invalid.</my-error>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-4">
                <div class="form-group mb-3">
                  <label class="form-label" for="transferReasonId">Posting Reason</label>
                  <select MyInput formControlName="transferReasonId" class="form-select form-select-sm">
                    <option value="" selected>--SELECT--</option>
                    <option *ngFor="let item of transferReasons" value="{{ item.value }}">{{ item.text }}
                    </option>
                  </select>
                  <my-error controlName="transferReasonId" errorKey="required">Posting Reason is required.</my-error>
                </div>
              </div>
              <!-- <div class="col-md-4">
                <div class="form-group mb-3">
                  <label class="form-label" for="transferCategoryId">Transfer Category</label>
                  <select MyInput formControlName="transferCategoryId" class="form-select form-select-sm">
                    <option value="" selected>--SELECT--</option>
                    <option *ngFor="let item of transferCategory" value="{{ item.value }}">{{ item.text }}
                    </option>
                  </select>
                  <my-error controlName="transferCategoryId" errorKey="required">Transfer Category is required.
                  </my-error>
                </div>
              </div> -->
              <div class="col-md-3">
                <div class="form-group mb-3">
                  <label class="form-label" for="leaveCount">Deductible Leave/Absence(days)</label>
                  <input (keypress)="numericOnly($event)" MyInput formControlName="leaveCount"
                    class="form-control form-control-sm" />
                  <my-error controlName="leaveCount" errorKey="required">Deductible Leave/Absence(days) is required.
                  </my-error>
                </div>
              </div>
            </div>
          </div>

          <div class="d-flex">
            <button class="btn btn-primary rounded-0 ml-auto mr-2" [disabled]="!serviceBookForm.valid || loading"
              type="submit">
              <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" *ngIf="loading"></span>
              Submit
            </button>
            <button *ngIf="id" type="button" (click)="delete()" class="btn btn-danger rounded-0">Delete</button>
          </div>
        </form>
      </div>

    </div>
  </div>
</div>